<template>
  <div class="panel-body">
    <div class="panel-body_head">
      <b-row>
        <b-col cols="8" class="d-flex justify-content-start">
          <b-col
            class="panel-body_chart-type compact"
            :class="{ active: activeView === 1 }"
            @click="changeView(1)"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
              <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"/>
              <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
            </svg>
            <span>Fields Map</span>
          </b-col>
          <b-col
            class="panel-body_chart-type compact"
            :class="{ active: activeView === 2 }"
            @click="changeView(2)"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-table" viewBox="0 0 16 16">
              <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 2h-4v3h4V4zm0 4h-4v3h4V8zm0 4h-4v3h3a1 1 0 0 0 1-1v-2zm-5 3v-3H6v3h4zm-5 0v-3H1v2a1 1 0 0 0 1 1h3zm-4-4h4V8H1v3zm0-4h4V4H1v3zm5-3v3h4V4H6zm4 4H6v3h4V8z"/>
            </svg>
            <span>Fields Table</span>
          </b-col>
          <b-form-group id="input-group-range" class="year-slider">
            <Slider
              v-if="yearRange"
              v-model="yearLimit"
              :min="yearRange[0]"
              :max="yearRange[1]"
            ></Slider>
          </b-form-group>
        </b-col>
        <b-col
          v-if="activeView !== 2"
          cols="4"
          class="d-flex justify-content-start"
        >
          <b-button
            id="popover-fields"
            size="sm"
            variant="outline-secondary"
            class="ml-auto mr-2"
            >Fields <i class="fa fa-caret-down"></i
          ></b-button>
          <b-popover
            target="popover-fields"
            triggers="focus"
            placement="bottom"
          >
            <template v-slot:title>
              Fields View Options
            </template>
            <b-form-checkbox v-model="showContour" size="sm" class="mr-2 mb-2"
              >Contour Background</b-form-checkbox
            >
            <b-form-checkbox v-model="showFields" size="sm" class="mr-2 mb-2"
              >Fields Size Bubble</b-form-checkbox
            >
            <b-form-checkbox
              v-model="showFieldsNames"
              size="sm"
              class="mr-2 mb-2"
              >Fields Names</b-form-checkbox
            >
            <b-form-checkbox v-model="showArrows" size="sm" class="mr-2 mb-2"
              >Field Trend Arrows</b-form-checkbox
            >
          </b-popover>
          <b-button
            id="popover-themes"
            size="sm"
            variant="outline-secondary"
            class="mr-2"
            >Themes <i class="fa fa-caret-down"></i
          ></b-button>
          <b-popover
            target="popover-themes"
            triggers="focus"
            placement="bottom"
          >
            <template v-slot:title>Themes View Options</template>
            <b-form-checkbox v-model="showThemes" size="sm" class="mr-2 mb-2"
              >Themes</b-form-checkbox
            >
            <b-form-checkbox
              v-model="showLabels"
              size="sm"
              class="mr-2 mb-2"
              :disabled="!showThemes"
              >Labels</b-form-checkbox
            >
          </b-popover>
          <b-button
            id="popover-documents"
            size="sm"
            variant="outline-secondary"
            class="mr-2"
            >Documents <i class="fa fa-caret-down"></i
          ></b-button>
          <b-popover
            target="popover-documents"
            triggers="focus"
            placement="bottom"
          >
            <template v-slot:title>Documents View Options</template>
            <b-form-checkbox v-model="showDocuments" size="sm" class="mr-2 mb-2"
              >Documents</b-form-checkbox
            >
            <b-form-checkbox
              v-model="showNonMatchingDocuments"
              size="sm"
              class="mr-2 mb-2"
              >Non matching Documents</b-form-checkbox
            >
            <b-form-checkbox
              v-model="showOverlappingDocuments"
              size="sm"
              class="mr-2 mb-2"
              >Overlapping Documents</b-form-checkbox
            >
          </b-popover>
          <b-button
            id="popover-rings"
            size="sm"
            variant="outline-secondary"
            >Rings <i class="fa fa-caret-down"></i
          ></b-button>
          <b-popover
            v-if="rings.levels.length > 0"
            target="popover-rings"
            triggers="focus"
            placement="bottom"
          >
            <template v-if="rings.levels[0].layers.length < 1" v-slot:title
              >No Rings Selected</template
            >
            <template v-else v-slot:title>Rings View Options</template>
            <b-form-checkbox
              v-if="rings.levels[0].layers.length > 0"
              v-model="showRings"
              :disabled="rings.levels[0].layers.length < 1"
              size="sm"
              class="mr-2 mb-2"
              >Rings</b-form-checkbox
            >
            <b-form-checkbox
              v-if="rings.levels[0].layers.length > 0"
              v-model="showRingsNoMatch"
              :disabled="rings.levels[0].layers.length < 1"
              size="sm"
              class="mr-2 mb-2"
              >Rings - No match</b-form-checkbox
            >
          </b-popover>
        </b-col>
      </b-row>
    </div>
    
    <div class="panel-body_content">
      <b-row class="mt-2 mb-2">
        <b-col v-if="activeView === 1">
          <div class="d-flex align-items-center mb-2">
                <label v-if="activeView === 1" size="sm">Set Rings</label>
                <label v-else size="sm">Set players in field</label>
                <b-btn
                  size="sm"
                  variant="primary"
                  class="ml-auto"
                  @click="viewRings"
                  >Update</b-btn
                >
          </div>
          <ExploreAnalysisCreateAxis
                :axis="rings"
                :multiple="false"
                :selectLimit=5
          ></ExploreAnalysisCreateAxis>
          <!--<b-row>
            <b-col>
              <b-btn size="sm" variant="info" @click="viewRings">Update</b-btn>
            </b-col>
          </b-row>-->
        </b-col>
        <b-col v-else>
          <h2 class="mx-0 my-2 text-center">
            <b-img src="/images/not-found.svg" title="No options" width="120" class="mb-1"></b-img>
            <p class="my-2">No Options Available</p>
          </h2>
          <!--<b-row class="mt-2">
            <b-col>
              <label size="sm">Min Connections</label>
              <b-form-input size="sm" v-model="minimumConnections" @blur="setMinimumConnections"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <label size="sm">Cut Off</label>
              <b-form-input size="sm" v-model="cutoff" @blur="setCutoff"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <b-form-group>
                <b-form-checkbox v-model="isolateFields" size="sm" switch>Isolate fields</b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-btn size="sm" variant="info" @click="viewRings">Update</b-btn>
            </b-col>
          </b-row>-->
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapState } from "vuex";
import AnalysisHelpers from "@/components/Explore/ExploreAnalysis/AnalysisHelpers";
import { EventBus } from "@/eventBus";
import ExploreAnalysisCreateAxis from "../ExploreAnalysisCreateAxis";
import Slider from "../Slider";

export default {
  name: "FieldsSettings",
  components: {
    ExploreAnalysisCreateAxis,
    Slider
  },
  data() {
    return {
      activeView: 1,
      showContour: true,
      showFields: true,
      showFieldsNames: true,
      showArrows: true,
      showThemes: false,
      showLabels: false,
      showDocuments: false,
      showNonMatchingDocuments: true,
      showOverlappingDocuments: true,
      showRings: false,
      showRingsNoMatch: false,
      isolateFields: false,
      minimumConnections: 2,
      cutoff: 0.2,
      associations: [{ layers: [["TTC", 1]] }],
      yearRange: null,
      yearLimit: [],
      years: [],
      rings: {}
    };
  },
  computed: {
    ...mapState({
      documentsPerYear: state => state.document.documentsPerYear,
      indices: state => state.ttc.indices,
      ringQuery: state => state.visualization.ringQuery
    }),
    ringStringified: {
      get() {
        return JSON.stringify(this.ring);
      },
      set(val) {
        this.query = JSON.parse(val);
      }
    }
  },
  watch: {
    showContour(value) {
      EventBus.$emit("showContourChanged", value);
    },
    showFields(value) {
      EventBus.$emit("showFieldsChanged", value);
    },
    showFieldsNames(value) {
      EventBus.$emit("showFieldsNamesChanged", value);
    },
    showArrows(value) {
      EventBus.$emit("showArrowsChanged", value);
    },
    showThemes(value) {
      EventBus.$emit("showThemesChanged", value);
    },
    showLabels(value) {
      EventBus.$emit("showLabelsChanged", value);
    },
    showDocuments(value) {
      EventBus.$emit("showDocumentsChanged", value);
    },
    showNonMatchingDocuments(value) {
      EventBus.$emit("showNonMatchingDocumentsChanged", value);
    },
    showOverlappingDocuments(value) {
      EventBus.$emit("showOverlappingDocumentsChanged", value);
    },
    showRings(value) {
      EventBus.$emit("showRingsChanged", value);
    },
    showRingsNoMatch(value) {
      EventBus.$emit("showRingsNoMatchChanged", value);
    },
    isolateFields(value) {
      EventBus.$emit("isolateFieldsChanged", value);
    },
    yearLimit(value) {
      if (this.years[0] !== value[0]) {
        this.years[0] = value[0];
        EventBus.$emit("setStartYear", value[0]);
      }
      if (this.years[1] !== value[1]) {
        this.years[1] = value[1];
        EventBus.$emit("setRecentYear", value[1]);
      }
      if (this.years[2] !== value[2]) {
        this.years[2] = value[2];
        EventBus.$emit("setStopYear", value[2]);
      }
    }
  },
  created() {
    this.initRings();
  },
  mounted() {
    this.initYears();
  },
  methods: {
    ...mapActions(["saveRingQuery"]),
    initRings() {
      this.rings = [];
      if (this.ringQuery !== null) {
        this.rings = this.ringQuery;
      } else {
        this.rings = {
          levels: [
            {
              id: 1,
              modifiers: [],
              grouped: false,
              includeAll: true,
              linked: false,
              layers: []
            }
          ]
        };
      }
    },
    initYears() {
      if (this.documentsPerYear.length > 0) {
        const yearMin = parseInt(_.minBy(this.documentsPerYear, "year").year);
        const yearMax = parseInt(_.maxBy(this.documentsPerYear, "year").year);
        this.yearRange = [yearMin, yearMax];
        this.yearLimit = [yearMin, yearMax - 2, yearMax];
        this.years = this.yearLimit;
      }
    },
    viewRings() {
      this.saveRingQuery(this.rings);
      EventBus.$emit("setRing", this.buildQueryLayers(this.rings));
    },
    buildQueryLayers(axis) {
      const preselect = { max: 20, overlap: this.activeView === 1 };
      const preselectWhenModifiersEmpty = { top: 5 };
      return AnalysisHelpers.buildQueryLayers(
        axis,
        preselect,
        preselectWhenModifiersEmpty
      );
    },
    setMinimumConnections(e) {
      EventBus.$emit("setMinimumConnections", e);
    },
    setCutoff(e) {
      EventBus.$emit("setCutoff", e);
    },
    setAssociations(e) {
      EventBus.$emit("setAssociations", e);
    },
    resetSettings() {
      this.showFields = true;
      this.showFieldsNames = true;
      this.showArrows = true;
      this.showThemes = false;
      this.showLabels = false;
      this.showDocuments = false;
      this.showNonMatchingDocuments = false;
      this.showOverlappingDocuments = false;
      this.showRings = false;
      this.showRingsNoMatch = false;
      this.isolateFields = false;
      this.minimumConnections = 2;
      this.cutoff = 0.2;
      this.associations = [{ layers: [["TTC", 1]] }];
      //this.initRings();
      //this.initYears();
    },
    changeView(view) {
      if (view !== this.activeView) {
        this.activeView === 1 ? (this.activeView = 2) : (this.activeView = 1);
        this.resetSettings();
        EventBus.$emit("changeView", {
          activeView: this.activeView
        });
      }
    }
  }
};
</script>
